import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiListDataService} from './api.list-data.service';
import {TaskModel} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ApiTaskService extends ApiListDataService<TaskModel, TaskModel> {

  constructor(http: HttpClient) {
    super(http, '/Task/');
  }
}
